import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Polyfill for process object (needed for simple-peer and other Node.js modules in browser)
// Must be after imports but before rendering
if (typeof process === 'undefined') {
    window.process = {
        env: {},
        // Use a microtask to better match Node's nextTick semantics.
        // Some libs (streams/webrtc shims) rely on nextTick being scheduled ASAP.
        nextTick: (fn, ...args) => {
            if (typeof queueMicrotask === 'function') {
                queueMicrotask(() => fn(...args));
            } else {
                Promise.resolve().then(() => fn(...args));
            }
        },
        version: '',
        versions: {},
        platform: 'browser',
        browser: true
    };
    if (typeof global !== 'undefined') {
        global.process = window.process;
    }
} else if (!process.env) {
    process.env = {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
